import {
    createCredentialGlobal,
    getCredentialGlobal,
    editCredentialByIdGlobal,
    deleteCredentialByIdGlobal,
    createServiceGlobal,
    getServices,
    editServiceByIdGlobal,
    deleteServiceByIdGlobal,
    createDepartmentGlobal,
    getDepartments,
    editDepartmentByIdGlobal,
    deleteDepartmentByIdGlobal,
    createJobGlobal,
    getJobs,
    editJobByIdGlobal,
    deleteJobByIdGlobal,
    createPlaceGlobal,
    getPlaces,
    editPlaceByIdGlobal,
    deletePlaceByIdGlobal,
    editCoveredCredential,
    createCoveredCredential,
    selectCredential,
    removeCredential,
    createCompany,
    getCompany,
    editCompany,
    deleteCompany,
    getConnectCalendars,
    disconnectCalendar,
    calendarStatus,
    stripeSettings,
    editBank,
    getBanks,
    deleteBanks,
    createBank,
    changeAiIntegration,
    getIntegrations,
    connectIntegration,
    disconnectIntegration,
    editIntegration,
    canUseIntegration,
    deleteIntegration,
    connectZoom,
    editZoomStatus,
    connectZoomToTherapy,
    createZoomMeeting,
    deleteZoomMeeting,
    getZoomUsers,
    getCompanies,
    connectGoogleMeet, connectGoogleMeetToTherapy, editGoogleMeetStatus,
    getTelehealthStatus,
    getSupervisionConfig,
    updateSupervisionConfig,
    updateClinicalSettings,
    getEligibilityAutoCheckConfig,
    updateEligibilityAutoCheckConfig,
    runBatchEligibilityCheck,
    getMembersPortalConfig,
    updateMembersPortalConfig,
} from './system.action';

export { systemReducer } from './system.reducer';
export { watchSystem } from './system.saga';

export const systemActions = {
    /** Service Type */
    createServiceGlobal,
    getServices,
    editServiceByIdGlobal,
    deleteServiceByIdGlobal,
    /** End */

    /** Credentials */
    createCredentialGlobal,
    getCredentialGlobal,
    editCredentialByIdGlobal,
    deleteCredentialByIdGlobal,
    createCoveredCredential,
    editCoveredCredential,
    selectCredential,
    removeCredential,
    /** End */

    /** Departments */
    createDepartmentGlobal,
    getDepartments,
    editDepartmentByIdGlobal,
    deleteDepartmentByIdGlobal,
    /** End */

    /** Job */
    createJobGlobal,
    getJobs,
    editJobByIdGlobal,
    deleteJobByIdGlobal,
    /** End */

    /** Place */
    createPlaceGlobal,
    getPlaces,
    editPlaceByIdGlobal,
    deletePlaceByIdGlobal,
    /** End */

    /** Company */
    createCompany,
    getCompany,
    editCompany,
    deleteCompany,
    getCompanies,
    /** End */

    /** Calendars */
    getConnectCalendars,
    disconnectCalendar,
    calendarStatus,
    /** End */

    /** Stripe */
    stripeSettings,
    /** End */

    /** Bank */
    createBank,
    getBanks,
    editBank,
    deleteBanks,
    /** End */

    /** Ai Integration */
    changeAiIntegration,
    /** End */

    /** Integrations */
    getIntegrations,
    connectIntegration,
    disconnectIntegration,
    editIntegration,
    canUseIntegration,
    deleteIntegration,
    /** End */

    /** Zoom */
    connectZoom,
    connectZoomToTherapy,
    editZoomStatus,
    createZoomMeeting,
    deleteZoomMeeting,
    getZoomUsers,
    /** End */

    /** Google Meet */
    connectGoogleMeet,
    connectGoogleMeetToTherapy,
    editGoogleMeetStatus,
    /** End */

    /** Telehealth */
    getTelehealthStatus,
    /** End */

    /** Supervision Config */
    getSupervisionConfig,
    updateSupervisionConfig,
    /** End */

    /** Clinical Settings */
    updateClinicalSettings,
    /** End */

    /** Eligibility Auto-Check Config */
    getEligibilityAutoCheckConfig,
    updateEligibilityAutoCheckConfig,
    runBatchEligibilityCheck,
    /** End */

    /** Members Portal Config */
    getMembersPortalConfig,
    updateMembersPortalConfig,
    /** End */
};